import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const IdentifyStyles = styled(OnboardingPage)``;

export const IdentifySubtitle = styled(UiTypography)`
  margin: -24px 0 24px;
  padding: 0 16px;
  text-align: center;
`;
